
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/modernization",
      function () {
        return require("private-next-pages/download/modernization/index.tsx");
      }
    ]);
  